import { put, call, takeLatest } from 'redux-saga/effects';

import { getFromPublicDir } from 'Modules/core/api';

import { configActions } from './actions';


function* getConfig() {
    const config = yield call(getFromPublicDir, 'config.json', {
        headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
        },
    });

    yield put(configActions.set(config));
}

export const sagas = [
    takeLatest(`${configActions.get}`, getConfig),
];
